// RECENT (docs/design/inbox.md §7, R3267): the notices of this session,
// newest first, on the INBOX page under NEEDS YOU.
//
// A toast stands for some seconds and then goes, and the notice column
// keeps only the lines on screen. The state keeps a ring of the newest
// notices (`GameState.recentNotices`, `notice_recent_max` of
// `[presentation.chrome]`), and this block shows it. Folded, it is one
// line: RECENT, the count and the newest notice. ▾ opens the rows: the
// wall time and the words of each notice, an error in the bad ink. The
// block writes no countdown, so the markup changes on a new notice alone.
//
// A press carries an `ib-c-` act, and `press.ts` hands it here.

import './recent.css';
import { briefing as S, notices as SN } from '../../gen/strings';
import { isoTime } from '../../locale/stamp';
import type { RecentNotice } from '../../state';
import { arrowFace } from '../arrowpress';
import { esc } from '../esc';
import type { InboxCtx } from './page';
import { onInboxPress } from './press';

/** The press of the line: it folds and opens the block. */
export const RECENT_ACT = 'ib-c-fold';

/** The fold of the block, for the life of the page. */
let open = false;

/** Folds the block (a test starts from the fold). */
export function foldRecent(): void {
  open = false;
}

function rowHtml(n: RecentNotice): string {
  // An error leads with the error glyph of the notice lane, so it never
  // rests on the ink alone (R3100).
  const text = n.error ? `${SN.glyph_error} ${n.text}` : n.text;
  return `<div class="rc-row${n.error ? ' bad' : ''}"><i>${esc(isoTime(n.unix))}</i>`
    + `<span title="${esc(text)}">${esc(text)}</span></div>`;
}

/** RECENT: the folded line, or the line and the rows; '' while no notice
 *  arrived in this session. */
export function recentHtml(c: InboxCtx): string {
  const list = c.state.recentNotices;
  const newest = list[list.length - 1];
  if (newest === undefined) return '';
  const title = open ? S.recent_fold_close : S.recent_fold_open;
  const line = `<button class="sl-line" data-act="${RECENT_ACT}" aria-expanded="${open}" title="${esc(title)}">`
    + `<b class="sl-name">${esc(S.recent_head)}</b><span class="sl-away">${list.length}</span>`
    + `<span class="sl-sum">${open ? '' : esc(newest.text)}</span>`
    + `<span class="sl-chev" aria-hidden="true">${arrowFace(open ? 'up' : 'down')}</span></button>`;
  if (!open) return `<div class="sl rc">${line}</div>`;
  const rows = list.slice().reverse().map(rowHtml).join('');
  return `<div class="sl rc open">${line}<div class="rc-rows">${rows}</div></div>`;
}

onInboxPress('ib-c-', (act) => {
  if (act === RECENT_ACT) open = !open;
});
